import { Crown, Shield } from 'lucide-react';

import { cn } from '@/lib/utils';

export const ROLE_LABELS: Record<string, string> = {
  PROPRIETARIO: 'Proprietário',
  SOCIO: 'Sócio',
  ASSOCIADO: 'Associado',
  ESTAGIARIO: 'Estagiário',
};

const ROLE_COLORS: Record<string, string> = {
  PROPRIETARIO:
    'bg-amber-200 text-amber-900 border border-amber-400 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700/50',
  SOCIO:
    'bg-blue-100 text-blue-900 border border-blue-300 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-700/50',
  ASSOCIADO:
    'bg-gray-100 text-gray-800 border border-gray-300 dark:bg-gray-800/50 dark:text-gray-300 dark:border-gray-600/50',
  ESTAGIARIO:
    'bg-emerald-50 text-emerald-900 border border-emerald-300 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-700/50',
};

/** Os papéis que se atribuem num convite (o Proprietário é quem criou o escritório). */
export const PAPEIS_DO_CONVITE = ['ASSOCIADO', 'ESTAGIARIO', 'SOCIO'] as const;

/** Proprietário e Sócio gerenciam membros, convites e equipes. */
export function podeGerir(papel: string | undefined): boolean {
  return papel === 'PROPRIETARIO' || papel === 'SOCIO';
}

export function RoleBadge({ role, className }: { role: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        ROLE_COLORS[role],
        className,
      )}
    >
      {role === 'PROPRIETARIO' && <Crown className="h-3 w-3" aria-hidden="true" />}
      {role === 'SOCIO' && <Shield className="h-3 w-3" aria-hidden="true" />}
      {ROLE_LABELS[role] || role}
    </span>
  );
}

/** As iniciais do nome, para o avatar. */
export function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/);
  return ((partes[0]?.[0] ?? '') + (partes.length > 1 ? partes[partes.length - 1][0] : '')).toUpperCase() || '?';
}

export function Avatar({ nome, className }: { nome: string; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-semibold text-muted-foreground',
        className,
      )}
    >
      {iniciais(nome)}
    </span>
  );
}
